import React from 'react';

export function Input({ label, error, required, ...props }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <label>
        {label}
        {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
        :
        <input
          {...props}
          style={{ 
            display: 'block',
            width: '100%',
            padding: '8px',
            marginTop: '4px',
            border: error ? '2px solid #de350b' : '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: error ? '#ffebe6' : 'white'
          }}
        />
      </label>
      {error && (
        <div style={{ color: '#de350b', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </div>
  );
}

export function Select({ label, options, error, required, ...props }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <label>
        {label}
        {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
        :
        <select
          {...props}
          style={{ 
            display: 'block',
            width: '100%',
            padding: '8px',
            marginTop: '4px',
            border: error ? '2px solid #de350b' : '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: error ? '#ffebe6' : 'white'
          }}
        >
          <option value="">Select {label}</option>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      {error && (
        <div style={{ color: '#de350b', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </div>
  );
}

export function Button({ children, variant = 'primary', ...props }) {
  const colors = {
    primary: { bg: '#00b359', color: 'white' },
    secondary: { bg: '#e74c3c', color: 'white' },
    danger: { bg: '#dc3545', color: 'white' },
    text: { bg: 'transparent', color: '#007bff' }
  };

  const buttonColors = colors[variant] || colors.primary;

  return (
    <button
      {...props}
      style={{
        padding: '8px 16px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        backgroundColor: buttonColors.bg,
        color: buttonColors.color,
        ...props.style
      }}
    >
      {children}
    </button>
  );
}

export function Table({ headers, children, extraHeader }) {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            {extraHeader && (
              <th style={{ textAlign: 'left', padding: '12px', borderBottom: '2px solid #dee2e6' }}>
                {extraHeader}
              </th>
            )}
            {headers.map((header, i) => (
              <th
                key={i}
                style={{
                  textAlign: 'left',
                  padding: '12px',
                  borderBottom: '2px solid #dee2e6'
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export function TableRow({ children, className = '', style = {}, ...props }) {
  // Expect callers to provide raw <td> cells so markup aligns exactly with headers
  return (
    <tr className={className} style={{ borderBottom: '1px solid #dee2e6', ...style }} {...props}>
      {children}
    </tr>
  );
}